<template>
  <fragment v-if="campaign">
    <div class="channel-edit-group channel-edit-group-fields">
      <div class="field-w">
        <b-field :label="$t('CampaignEdit.Projects.Title')">
          <b-dropdown :value="campaignEditSelectedProjectsIds" multiple scrollable aria-role="list" class="multiple"
                @active-change="onDropdownActiveChange" @change="onSelectedProjectsIdsChange($event)">
            <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">{{ $t("CampaignEdit.Projects.Title") }} ({{ campaignEditSelectedProjectsIds.length }})</span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
            </template>
            <b-dropdown-item custom aria-role="listitem" class="filter-search">
              <b-input v-model="projectSearch" class="search" :placeholder="$t('Search')" expanded />
            </b-dropdown-item>
            <b-dropdown-item v-for="project in projectsFiltered" :key="project.ID" :value="project.ID" aria-role="listitem">
              <span class="text">{{ project.Title }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </b-field>
      </div>
    </div>
  </fragment>
</template>

<script lang="ts">
import Fragment from "vue-fragment";
import { Component, Vue, Watch } from "vue-property-decorator";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/he";
import { Action, Getter } from "vuex-class";
import { Campaign, CampaignEditViewModel } from "@/models/campaigns/Campaign";
import { CampaignEditPageKind } from "@/models/campaigns/CampaignEditPageKind";
import { CampaignEditProjectsData } from "@/models/campaigns/CampaignEditProjectsData";
import { Commitment } from "@/models/projects/Commitment";
import CampaignService from "@/services/CampaignService";
import HelperService from "@/services/HelperService";
import CampaignsApiService from "@/services/api/CampaignsApiService";
import IconBase from "../IconBase.vue";
import IconCaretDown from "../icons/IconCaretDown.vue";

Vue.use(Fragment.Plugin);
const namespace = "campaignsModule";

@Component({
  components: {
    IconBase,
    IconCaretDown,
  },
})
export default class TabProjects extends Vue {

  //#region Vuex getters and actions

  @Getter("campaignEditSelectedProjectsIds", { namespace }) campaignEditSelectedProjectsIds!: number[];
  @Getter("campaignEditViewModel", { namespace }) campaignEditViewModel!: CampaignEditViewModel;
  @Action("setCampaignEditSelectedProjectsIds", { namespace }) setCampaignEditSelectedProjectsIds!: (campaignEditSelectedProjectsIds: number[]) => Promise<void>;

  //#endregion Vuex getters and actions


  //#region Properties

  projectSearch = "";
  campaignEditProjectsData?: CampaignEditProjectsData = {
    Performances: [],
    ProjectIds: []
  };

  CampaignEditPageKind = CampaignEditPageKind;

  //#endregion Properties


  //#region Watchers

  @Watch("campaignEditViewModel", { immediate: true })
  onCampaignEditViewModelChange(newCampaignEditViewModel: CampaignEditViewModel, oldCampaignEditViewModel: CampaignEditViewModel): void {
    if (!newCampaignEditViewModel) {
      return;
    }
    CampaignsApiService.getCampaignEditProjectsData(this.campaign).then((data: CampaignEditProjectsData) => {
      this.campaignEditProjectsData = data;
      this.setCampaignEditSelectedProjectsIds(data.ProjectIds);
    });
  }

  //#endregion Watchers


  //#region Getters

  get campaign(): Campaign {
    return this.campaignEditViewModel?.Campaign;
  }

  get pageKind(): CampaignEditPageKind {
    return CampaignService.getCampaignEditPageKind(this.$route.path);
  }

  get projectsFiltered(): Commitment[] {
    if (this.campaignEditProjectsData) {
      return this.campaignEditProjectsData.Performances.filter((i: Commitment) => i.Title.toLowerCase().indexOf(this.projectSearch.toLowerCase()) >= 0);
    }
    return [];
  }

  //#endregion Getters


  //#region Handlers

  onDropdownActiveChange(show: boolean) {
    HelperService.onDropdownActiveChange(show);
  }

  onSelectedProjectsIdsChange(selectedProjectsIds: number[]) {
    this.setCampaignEditSelectedProjectsIds(selectedProjectsIds);
  }

  //#endregion Handlers
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.channel-edit-group {
  margin-bottom: 25px;

  &.channel-edit-group-field {
    max-width: 894px;

    .channel-edit-field {
      margin-bottom: 1rem;
    }

    .label {
      font-size: 17px;
      margin: 0;
      display: inline;
    }
  }

  &.channel-edit-group-fields {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -12px;

    .field-w {
      padding: 0 12px 25px;
      flex-grow: 1;
      width: 50%;

      .dropdown {
        width: 100%;

        .dropdown-item-with-icon {
          display: flex;

          .icon-w {
            display: flex;
            margin-inline-end: 0.5rem;
            min-width: 22px;

            img {
              max-height: 22px;
              min-width: 22px;
              width: 22px;
            }
          }
        }

        .dropdown-trigger {

          .button {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
